import { useNavigate } from "react-router-dom";

import NotificationForm from "../components/notifications/NotificationForm";

import "../styles/NotificationForm.css";

const CreateNotification = () => {

    const navigate = useNavigate();

    return (

        <div className="notification-form-page">

            <div className="page-header">

                <h2>Create Notification</h2>

                <button
                    className="back-btn"
                    onClick={() => navigate(-1)}
                >
                    Back
                </button>

            </div>

            <NotificationForm />

        </div>

    );

};

export default CreateNotification;